import { createSlice } from "@reduxjs/toolkit";
import { MatrixMahs } from "../../types/matrixMah";

export interface MatrixState {
  mahs: MatrixMahs[];
  isLoading: boolean;
}

// Deprecated: This slice is no longer used in the application. The MatrixPage component is currently disconnected from the UI, and the legacy v1 fetch has been removed.
// If a v2 endpoint is implemented in the future, this slice may be restored to manage the state of MAHs for the MatrixPage.
export const matrixSlice = createSlice({
  name: "matrix",

  initialState: {
    mahs: [],
    isLoading: true,
  } as MatrixState,

  reducers: {
    setMahsForMatrix: (state, action) => {
      state.mahs = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});

export const actions = {
  ...matrixSlice.actions,
};
